import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ErrorDialogData } from './error-dialog.data';

@Component({
    selector : 'error-dialog',
    template: require('./error-dialog.component.html'),
    styles: [require('./error-dialog.component.scss')]
})
export class ErrorDialogComponent {
    constructor(
        private dialogRef: MatDialogRef<ErrorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ErrorDialogData) {
    }

    public close() {
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/error-dialog/error-dialog.component.ts